/*
 * @Author: yejianfei
 * @Date: 2022-05-28 18:22:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-28 12:10:52
 * @Description:
 * @Developer:
 */
import React, { useEffect, useState, useRef } from 'react';
import { Form, Table } from 'antd';
import Api from '../../api';
import APIFormModal from './APIFormModal';
const api = Api();
export default function APITable(props) {
    var _a;
    const [scrollY, setScrollY] = useState(0);
    const table = useRef(null);
    const searchForm = useRef(null);
    const params = Object.assign(Object.assign({}, (props.initialParams || {})), (props.params || {}));
    const [pageIndex, setPage] = useState((params === null || params === void 0 ? void 0 : params.page) || 1);
    const [scroll, setScroll] = useState(true);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [isModalOpened, setModalOpened] = useState(props.modal);
    const [selected, setSelected] = useState(undefined);
    const load = (url, params) => {
        setLoading(true);
        api.get(url, { params: Object.assign({}, (params || {})) })
            .then((res) => {
            setData(res.list);
            setCount(res.count);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const remove = (url, id) => {
        setLoading(true);
        api.delete(url, { data: id })
            .then((res) => {
            if (props.loader) {
                load(props.loader, params);
            }
        });
    };
    const onWindowReize = () => {
        var _a;
        setScrollY((((_a = table.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0) - 60);
    };
    useEffect(() => {
        window.addEventListener('resize', onWindowReize);
        onWindowReize();
        return () => {
            window.removeEventListener('resize', onWindowReize);
        };
    }, []);
    useEffect(() => {
        props.loader && load(props.loader, params);
        setPage(1);
    }, [props.params]);
    useEffect(() => {
        props.form && setModalOpened(props.modal);
    }, [props.modal]);
    const pagination = props.pagination && Object.assign(Object.assign({}, (props.pagination || {})), { defaultCurrent: params.page || 1, defaultPageSize: params.size || 10, total: count, current: pageIndex, onChange: (page, size) => {
            setPage(page);
            props.loader && load(props.loader, Object.assign(Object.assign({}, params), { page, size }));
        } });
    const instance = {
        modal: (value) => {
            setModalOpened(true);
            setSelected(value);
        },
        delete: (value) => {
            if (props.form && props.form.action && value) {
                remove(props.form.action, [value]);
            }
        },
        search() {
            setTimeout(() => {
                var _a;
                props.loader
                    && load(props.loader, Object.assign(Object.assign({}, (props.initialParams || {})), (((_a = searchForm.current) === null || _a === void 0 ? void 0 : _a.getFieldsValue()) || {})));
            });
        }
    };
    const columns = (props.columns || []).map((item) => (Object.assign(Object.assign({}, item), (item.render
        ? {
            render: (value, record, index) => {
                return item.render && item.render(value, record, index, instance);
            }
        }
        : {}))));
    return (React.createElement(React.Fragment, null,
        ((_a = props.search) === null || _a === void 0 ? void 0 : _a.children) && (React.createElement(Form, { ref: searchForm }, props.search.children(instance))),
        React.createElement(Table, Object.assign({}, props, { columns: columns, loading: loading, dataSource: props.loader ? data : props.data, pagination: pagination, scroll: props.scroll || { y: scrollY }, ref: table })),
        props.form && (React.createElement(APIFormModal, { title: props.form.title, form: Object.assign(Object.assign({}, props.form), { value: selected, onRequestSucceeded: (method, res, values) => {
                    var _a, _b;
                    if (props.loader) {
                        method === 'post'
                            ? load(props.loader, props.initialParams || {})
                            : load(props.loader, params);
                    }
                    ((_a = props.form) === null || _a === void 0 ? void 0 : _a.onRequestSucceeded) && ((_b = props.form) === null || _b === void 0 ? void 0 : _b.onRequestSucceeded(method, res, values));
                } }), open: isModalOpened, afterClose: () => {
                setModalOpened(false);
                props.onModalAfterClose && props.onModalAfterClose();
            } }, props.form.children))));
}
